
<template>    
  <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
  <!-- D: border가 없는경우 type-non-border 추가 -->
            <div class="c-tab-panel-wrap type-non-border">
              <!-- tab content: tab1 - AI 조색배합 -->
              <div
                class="tab-panel"
                role="tabpanel"
                aria-labelledby="tab1-1">

                <!-- AI 조색배합 타이틀 -->
                <div class="c-hgroup">
                  <h2 class="c-title-level2">

                    AI 조색 배합
                  </h2>
                </div>

                <!-- 3단계 프로세스 -->
                <div class="ai-process-wrap">
                  <!-- 프로세스 컨테이너 -->
                  <div class="process-container">             
                    <!-- Step 1: 제품선택 -->
                    <div class="process-step step1">
                      <!-- 배합결과 이력 확인 -->
                      <div class="content-section">
                        <div class="c-mo-toggle-box">
          
                          <div class="c-select c-select-full">    
                            <select name="historyFilterType" title="배합결과 이력 구분 선택"  v-model="data.searchHis" @change="getColorHis()">
                              <option value="" selected disabled>배합결과 이력 구분 선택</option>
                              <option
                                v-for="(item, index) in data.recipeHistList"
                                :key="index"
                                :value="item.HIS_API_SN"
                              >
                                {{ item.CNID }} / {{ item.PDGPNAME }} / {{ item.REG_DATE }} 
                              </option> 
                              <option v-if="data.recipeHistList.length < 1">배합결과가 없습니다.</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="product-info-box" v-if=" ( data.colorCombin15 && Object.keys(data.colorCombin15).length ) || ( data.colorCombin18 && Object.keys(data.colorCombin18).length)">
                                    
                        <ul class="c-dot-list type-small product-info-list"  v-if="  data.colorCombin15 && Object.keys(data.colorCombin15).length ">
                          <li>
                            <span class="info-label">팬톤조색제</span>
                          </li>
                          <li>
                            <span class="info-label">제품명</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.NAME}}</span>
                          </li>
                          <li>
                            <span class="info-label">색상명</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.CNID}}<span
                                class="color-chip"
                                :style="{backgroundColor:  `rgb(${data.colorCombin15.DF_RGB_R}, ${data.colorCombin15.DF_RGB_G}, ${data.colorCombin15.DF_RGB_B})` }" 
                                role="img"
                                aria-label="NR1021 색상 미리보기"></span>
                            </span>
                          </li>
                          <li>
                            <span class="info-label">광택</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.POLISHTYPE}}</span>
                          </li>
                          <li>
                            <span class="info-label">규격</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.PDLV}}</span>
                          </li>
                          <li>
                            <span class="info-label">베이스</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.PAINTBASE}}</span>
                          </li>
                          <li>
                            <span class="info-label">예상 색차이(△E)</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.DF_DELTA_E}}</span>
                          </li>
                          <li>
                            <span class="info-label">조색제 가격</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin15.DF_PRICE}}원</span>
                          </li>
                          <li class="color-underline color-vertical">
                            <span class="info-label">조색제</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              <span class="color-items">
                                <span class="color-item" v-if="data.colorCombin15.C01 > 0">IOR(W) {{data.colorCombin15.C01}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C02 > 0">Green(W) {{data.colorCombin15.C02}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C03 > 0">Blue(W) {{data.colorCombin15.C03}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C04 > 0">Violet(W) {{data.colorCombin15.C04}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C05 > 0">Black(W) {{data.colorCombin15.C05}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C06 > 0">White(W) {{data.colorCombin15.C06}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C07 > 0">YIO(W) {{data.colorCombin15.C07}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C09 > 0">SPRED(W) {{data.colorCombin15.C09}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C10 > 0">Yel2GxD(W) {{data.colorCombin15.C10}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C11 > 0">MAGENTA(W) {{data.colorCombin15.C11}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C12 > 0">Yel.HRD(W) {{data.colorCombin15.C12}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C13 > 0">Lem.Yel(W) {{data.colorCombin15.C13}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C14 > 0">Br.Org(W) {{data.colorCombin15.C14}}</span>
                                <span class="color-item" v-if="data.colorCombin15.C15 > 0">Rbn.Red(W) {{data.colorCombin15.C15}}</span>
                              </span>
                            </span>
                          </li>
                        </ul>
                        <ul class="c-dot-list type-small product-info-list"  v-if=" data.colorCombin18 && Object.keys(data.colorCombin18).length">
                          <li>
                            <span class="info-label">일반조색제</span>
                          </li>
                          <li>
                            <span class="info-label">제품명</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.NAME}}</span>
                          </li>
                          <li>
                            <span class="info-label">색상명</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.CNID}}<span
                                class="color-chip"
                                :style="{backgroundColor:  `rgb(${data.colorCombin18.DF_RGB_R}, ${data.colorCombin18.DF_RGB_G}, ${data.colorCombin18.DF_RGB_B})` }" 
                                role="img"
                                aria-label="NR1021 색상 미리보기"></span>
                            </span>
                          </li>
                          <li>
                            <span class="info-label">광택</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.POLISHTYPE}}</span>
                          </li>
                          <li>
                            <span class="info-label">규격</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.PDLV}}</span>
                          </li>
                          <li>
                            <span class="info-label">베이스</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.PAINTBASE}}</span>
                          </li>
                          <li>
                            <span class="info-label">예상 색차이(△E)</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.DF_DELTA_E}}</span>
                          </li>
                          <li>
                            <span class="info-label">조색제 가격</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              {{data.colorCombin18.DF_PRICE}}원</span>
                          </li>
                          <li class="color-underline color-vertical">
                            <span class="info-label">조색제</span>
                            <span class="info-colon">:</span>
                            <span class="info-value">
                              <span class="color-items">
                                <span class="color-item" v-if="data.colorCombin18.C01 > 0">IOR(W) {{data.colorCombin18.C01}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C02 > 0">Green(W) {{data.colorCombin18.C02}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C03 > 0">Blue(W) {{data.colorCombin18.C03}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C04 > 0">Violet(W) {{data.colorCombin18.C04}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C05 > 0">Black(W) {{data.colorCombin18.C05}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C06 > 0">White(W) {{data.colorCombin18.C06}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C07 > 0">YIO(W) {{data.colorCombin18.C07}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C09 > 0">SPRED(W) {{data.colorCombin18.C09}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C10 > 0">Yel2GxD(W) {{data.colorCombin18.C10}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C11 > 0">MAGENTA(W) {{data.colorCombin18.C11}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C12 > 0">Yel.HRD(W) {{data.colorCombin18.C12}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C13 > 0">Lem.Yel(W) {{data.colorCombin18.C13}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C14 > 0">Br.Org(W) {{data.colorCombin18.C14}}</span>
                                <span class="color-item" v-if="data.colorCombin18.C15 > 0">Rbn.Red(W) {{data.colorCombin18.C15}}</span>
                              </span>
                            </span>
                          </li>
                        </ul>
                      </div>



                     <div class="step-header">
                        <h3 class="c-title-level3">Step 1. 제품선택</h3>
                        <button type="button" class="c-util-button type-primary type-small" 
                          v-if=" ( data.colorCombin15 && Object.keys(data.colorCombin15).length ) || ( data.colorCombin18 && Object.keys(data.colorCombin18).length)"
                          @click="getHisSearchReset()">
                          <span>초기화</span>
                        </button>
                      </div>

                      <div class="step-content">

                        <!-- 제품유형 -->
                        <div class="content-section">
                          <div class="c-mo-toggle-box">
                            <div class="c-select c-select-full">
                              <select name="productType" title="제품유형 선택" @change="getProductList()" v-model="data.paintType">
                                <option value="" selected disabled>제품유형 선택</option>
                                <option
                                  v-for="(item, index) in data.selectBox.paintType"
                                  :key="index"
                                  :value="item.PTYPE"
                                >
                                  {{ item.PNAME }}
                                </option> 
                              </select>
                            </div>
                          </div>
                        </div>

                       <!-- 제품명 -->
                       <div class="content-section">
                         <div class="c-mo-toggle-box">
                           <div class="c-select c-select-full">
                             <select name="productName" title="제품명 선택" @change="getPolishType()" v-model="data.product">
                               <option value="" selected disabled>제품명 선택</option>
                                <option
                                  v-for="(item, index) in data.selectBox.prodList"
                                  :key="index"
                                  :value="item.PDGPID"
                                >
                                  {{ item.PDIDNAME }}
                                </option> 
                             </select>
                           </div>
                         </div>
                       </div>

                       <!-- 광택 -->
                       <div class="content-section">
                         <div class="c-mo-toggle-box">
                           <div class="c-select c-select-full">
                             <select name="gloss" title="광택 선택" @change="getPdlv()" v-model="data.polishType">
                               <option value="" selected disabled>광택 선택</option>
                                <option
                                  v-for="(item, index) in data.selectBox.polishTypeList"
                                  :key="index"
                                  :value="item.POLISHTYPE"
                                >
                                  {{ item.POLISHTYPE }}
                                </option> 
                             </select>
                           </div>
                         </div>
                       </div>

                       <!-- 규격 -->
                       <div class="content-section">
                         <div class="c-mo-toggle-box">
                           <div class="c-select c-select-full">
                             <select name="size" title="규격 선택" @change="getProdList()"  v-model="data.pdlv">
                               <option value="" selected disabled>규격 선택</option>
                                <option
                                  v-for="(item, index) in data.selectBox.pdlvList"
                                  :key="index"
                                  :value="item.PDLV"
                                >
                                  {{ item.PDLV }}
                                </option> 
                             </select>
                           </div>
                         </div>
                       </div>


                      </div>


                    </div>

                    <!-- Step 2: 색상선택 -->
                    <div class="process-step step2">
                      <div class="step-header">
                        <h3 class="c-title-level3">Step 2. 색상선택</h3>

                      </div>

                      <div class="step-content">
                        <!-- 안내 문구 -->
                        <div class="notice-box">
                          <p class="c-text-level2">
                            색상명은 띄어쓰기 없이 최소 3글자 이상을 입력하십시요.<br>
                            화면 설정 및 상태에 따라 칼라북 색상이 상이하게 보일 수 있습니다.
                          </p>
                        </div>
                        <div class="c-search">
                          <h2 class="sr-only">검색 영역</h2>
                          <div class="search-form">
                            <label class="sr-only">제품검색</label>
                            <!-- D: MO에서는 input readonly 추가 필요합니다(레이어팝업 오픈하기 위함) -->
                            <input
                              type="text"
                              id="searchQuery"
                              title="검색"
                              class="search-input"
                              autocomplete="off"
                              placeholder="예) NR102"
                                ref="myInput"
                              v-model="data.colorCombin.search.searchKeyword"
                              value=""
                              @keypress.enter="getColormameRgb"
                              @keyword-changed="getColormameRgb"
                               @mousedown="handleMouseDown">
                            <button type="button" class="search-cancel"  @click="getSearchReset()">
                              <i class="c-icon icon-large-x"></i>
                              <span class="sr-only">검색어 재입력</span>
                            </button>
                            <button type="button" class="search-submit" @click="getColormameRgb()">
                              <span class="sr-only">검색</span>
                            </button>
                          </div>
                          <!-- search layer -->
                          <div class="search-layer">
                            <div class="search-layer-inner">
                              <div class="c-text-tabs type-small">
                                <ul>
                                  <li class="tab-item">
                                    <!-- D: is-active, 추가 활성화 -->
                                    <a
                                      href="#tab1-1"
                                      class="tab-anchor is-active"
                                      role="tab"
                                      aria-selected="">최근검색어</a>
                                  </li>
                                  <li class="tab-item">
                                    <a
                                      href="#tab1-2"
                                      class="tab-anchor"
                                      role="tab">인기검색어</a>
                                  </li>
                                </ul>
                              </div>

                              <!-- D: 탭 전체 -->
                              <div class="tab-panel-wrap">
                                <!-- D: 탭 내용: 최근 검색어 -->
                                <div
                                  id="tab1-1"
                                  class="tab-panel"
                                  role="tabpanel">
                                  <h3 class="sr-only">최근 검색어 탭 내용</h3>
                                  <!-- D: 검색내역 -->
                                  <ul class="search-result-list">
                                    <li class="search-result-item">
                                      <a href="javascript:void(0);" class="result">말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트말줄임 테스트</a>
                                      <span class="date">10.21</span>
                                      <button type="button" class="btn-delete">
                                        <span class="c-icon icon-small-x"></span>
                                        <span class="sr-only">검색어 삭제</span>
                                      </button>
                                    </li>
                                    <li class="search-result-item">
                                      <a href="javascript:void(0);" class="result">수성</a>
                                      <span class="date">10.21</span>
                                      <button type="button" class="btn-delete">
                                        <span class="c-icon icon-small-x"></span>
                                        <span class="sr-only">검색어 삭제</span>
                                      </button>
                                    </li>
                                    <li class="search-result-item">
                                      <a href="javascript:void(0);" class="result">수성</a>
                                      <span class="date">10.21</span>
                                      <button type="button" class="btn-delete">
                                        <span class="c-icon icon-small-x"></span>
                                        <span class="sr-only">검색어 삭제</span>
                                      </button>
                                    </li>
                                  </ul>
                                  <!-- D: 검색어가 없을 경우 -->
                                  <div class="search-nodata">
                                    <p class="text">최근 검색어가 없습니다.</p>
                                  </div>
                                  <button type="button" class="c-button type-line-white type-small">
                                    <span>전체 삭제</span>
                                  </button>
                                </div>
                                <!-- D: 탭 내용: 인기 검색어 -->
                                <div
                                  id="tab1-2"
                                  class="tab-panel"
                                  role="tabpanel"
                                  hidden="">
                                  <h3 class="sr-only">인기 검색어 탭 내용</h3>
                                  <div class="popularity-wrap">
                                    <!-- D: 1열 -->
                                    <ul class="search-result-list">
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">01.수성</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">02.건축용</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">03.순&amp;수</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">04.순&amp;수</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">05.순&amp;수</a>
                                      </li>
                                    </ul>
                                    <!-- D: 2열 -->
                                    <ul class="search-result-list">
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">06.수성</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">07.건축용</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">08.순&amp;수</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">09.순&amp;수</a>
                                      </li>
                                      <li class="search-result-item">
                                        <a href="javascript:void(0);" class="result">10.순&amp;수</a>
                                      </li>
                                    </ul>
                                  </div>
                                  <!-- D: 검색어가 없을 경우 -->
                                  <div class="search-nodata">
                                    <p class="text">최근 검색어가 없습니다.</p>
                                  </div>
                                  <span class="search-date">2024-10-21 기준</span>
                                </div>
                              </div>

                              <!-- D: 입력시 노출, 탭 숨김 -->
                              <div class="keydown-result" hidden="">
                                <ul class="search-result-list">
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축
                                      <span class="color-primary">수성</span>
                                    </a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축 내부<span class="color-primary">수성</span>용</a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축
                                      <span class="color-primary">수성</span>
                                    </a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축 내부<span class="color-primary">수성</span>용</a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축
                                      <span class="color-primary">수성</span>
                                    </a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축 내부<span class="color-primary">수성</span>용</a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축
                                      <span class="color-primary">수성</span>
                                    </a>
                                  </li>
                                  <li class="search-result-item">
                                    <a href="javascript:void(0);" class="result">건축 내부<span class="color-primary">수성</span>용</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <button type="button" class="search-layer-close">
                              <i class="c-icon icon-small-white-x"></i>
                              <span>닫기</span>
                            </button>
                          </div>
                        </div>
                        <!-- 색상 선택 영역 -->
                        <div class="color-selector">


                          <!-- 색상 리스트 -->
                          <div class="color-list">

                            <!-- 색상 아이템 1 -->
                            <a href="javascript:void(0);" class="color-item" @click="setRecipeIndex(index)"
                                  v-for="(item, index) in data.colornameRgbListSearch" :key="item.CBID" >
                              <div class="color-swatch" :style="{backgroundColor:  `rgb(${item.RGB_R}, ${item.RGB_G}, ${item.RGB_B})` }" ></div>
                              <div class="color-info" :data-index="index">
                                <p class="color-code">{{ item.CNID }}</p>
                                <p class="color-name">{{ item.CBNAME }}</p>
                                <p class="color-lab">L:{{item.LAB_L}} A:{{item.LAB_A}} B:{{item.LAB_B}}</p>
                                <!-- <p class="color-note">자동조색기에 배합이 있습니다.</p> -->
                              </div>
                            </a>

                            
                          </div>
                        </div>

                        <!-- 배합 설계 버튼 -->

                        <div class="c-btn-area has-fixed-visible">
                          <button
                            type="button"
                            class="c-button type-secondary"
                            @click="getPaintTypeList()"
                            style="--btn-width:280px;">
                            <span>초기화</span>
                          </button>
                          <button
                            type="submit"
                            class="c-button type-primary"
                            @click="getRecipeByCb15()"
                            style="--btn-width:280px;">
                            <span>배합설계</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Step 3: 배합결과 -->
                    <div class="process-step step3">
                      <div class="step-header">
                        <h3 class="c-title-level3">Step 3. 배합결과</h3>
                      </div>

                      <div class="step-content">
                        <!-- 결과 안내 -->
                        <div class="result-notice">
                          <h4 class="c-title-level4">배합 필수 확인 사항</h4>
                          <ul class="c-dot-list type-small">
                            <li>배합이 도출되지 않는 경우 페인트 프로 조색배합 문의를 이용해 주시기 바랍니다.</li>
                            <li>데이터 학습에 따라 배합 결과가 변경될 수 있습니다.</li>
                            <li>동일한 색상명에서 시중품 색상, 자동조색 색상, AI 색상이 차이가 발생할 수 있습니다.</li>
                            <li>첫 번째 조색 제품의 색상과 의뢰 받으신 색상을 반드시 확인하신 후 나머지 도료의 조색을 진행 하시기 바랍니다.</li>
                            <li>팬톤조색제 배합은 조색제의 개수가 14개 중에서 배합이 도출되며, 일반조색제 배합은 11개 중에서 배합이 도출됩니다. 일반조색제가 팬톤조색제에 포함되기 때문에 동일한 결과가 도출될 수 있습니다.</li>
                            <li>목표 색상은 칼라북의 색상이며, 추천색상은 도출 색상의 표시입니다.</li>
                          </ul>
                        </div>

                        <!-- 배합결과 -->
                        <div class="result-cards-wrap-row">
                          <div class="result-cards-wrap" >
                            <!-- 팬톤조색제 배합 -->
                            <div v-for="(item, index) in data.recipe15List" :key="item.gtype" >
                              <div class="result-card"  v-if="index === 0">
                                <h4 class="result-card-title">팬톤조색제 배합</h4>
                                <div class="result-card-content" :data-index="index">
                                  <!-- 색상 견본 -->
                                  <div class="color-preview">
                                    <div class="color-col">
                                      <div class="preview-label">
                                        <p class="label-text">목표색상</p>
                                      </div>
                                      <div class="color-box" :style="{backgroundColor:  `rgb(${item.DF_RGB_R}, ${item.DF_RGB_G}, ${item.DF_RGB_B})` }"></div>
                                    </div>
                                    <div class="color-col">
                                      <div class="preview-label">
                                        <p class="label-text">예측색상</p>
                                      </div>
                                      <div class="color-box" :style="{backgroundColor:  `rgb(${item.RGB_R}, ${item.RGB_G}, ${item.RGB_B})` }"></div>
                                    </div>
                                  </div>

                                  <!-- 배합 정보 -->
                                  <div class="mixing-info">
                                    <div class="product-info-box">
                                      <ul class="c-dot-list type-small product-info-list">
                                      <li>
                                        <span class="info-label">제품명</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{ data.productNm }}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">색상명</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.cnid}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">광택</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.polishType}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">규격</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.pdlv}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">베이스</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.PAINTBASE}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">색차이(△E)</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.DF_DELTA_E}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">조색제 가격</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.DF_PRICE}}원 / {{data.pdlv}} </span>
                                      </li>
                                      <li class="color-vertical">
                                        <span class="info-label">조색제</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value">
                                          <span class="color-items">
                                            <span class="color-item" v-if="item.C01 > 0">IOR(W) {{item.C01}}</span>
                                            <span class="color-item" v-if="item.C02 > 0">Green(W) {{item.C02}}</span>
                                            <span class="color-item" v-if="item.C03 > 0">Blue(W) {{item.C03}}</span>
                                            <span class="color-item" v-if="item.C04 > 0">Violet(W) {{item.C04}}</span>
                                            <span class="color-item" v-if="item.C05 > 0">Black(W) {{item.C05}}</span>
                                            <span class="color-item" v-if="item.C06 > 0">White(W) {{item.C06}}</span>
                                            <span class="color-item" v-if="item.C07 > 0">YIO(W) {{item.C07}}</span>
                                            <span class="color-item" v-if="item.C09 > 0">SPRED(W) {{item.C09}}</span>
                                            <span class="color-item" v-if="item.C10 > 0">Yel2GxD(W) {{item.C10}}</span>
                                            <span class="color-item" v-if="item.C11 > 0">MAGENTA(W) {{item.C11}}</span>
                                            <span class="color-item" v-if="item.C12 > 0">Yel.HRD(W) {{item.C12}}</span>
                                            <span class="color-item" v-if="item.C13 > 0">Lem.Yel(W) {{item.C13}}</span>
                                            <span class="color-item" v-if="item.C14 > 0">Br.Org(W) {{item.C14}}</span>
                                            <span class="color-item" v-if="item.C15 > 0">Rbn.Red(W) {{item.C15}}</span>
                                          </span>
                                        </span>
                                      </li>
                                    </ul>
                                    </div>
                                    <button type="button" class="c-util-button type-primary btn-print">
                                      <span>배합인쇄</span>
                                    </button>
                                  </div>
                                </div>
                            </div>
                            </div>
                          </div>

                        
                        <div class="result-cards-wrap" >  
                          <!-- 팬톤조색제 배합 -->
                          <div   v-for="(item, index) in data.recipe18List" :key="item.gtype" >
                            <div  class="result-card" v-if="index == 0">
                              <h4 class="result-card-title">일반조색제 배합</h4>
                              <div class="result-card-content" :data-index="index">
                                <!-- 색상 견본 -->
                                <div class="color-preview">
                                  <div class="color-col">
                                    <div class="preview-label">
                                      <p class="label-text">목표색상</p>
                                    </div>
                                    <div class="color-box" :style="{backgroundColor:  `rgb(${item.DF_RGB_R}, ${item.DF_RGB_G}, ${item.DF_RGB_B})` }"></div>
                                  </div>
                                  <div class="color-col">
                                    <div class="preview-label">
                                      <p class="label-text">예측색상</p>
                                    </div>
                                    <div class="color-box" :style="{backgroundColor:  `rgb(${item.RGB_R}, ${item.RGB_G}, ${item.RGB_B})` }"></div>
                                  </div>
                                </div>

                                <!-- 배합 정보 -->
                                <div class="mixing-info">
                                  <div class="product-info-box">
                                  <ul class="c-dot-list type-small product-info-list">
                                      <li>
                                        <span class="info-label">제품명</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{ data.productNm }}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">색상명</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.cnid}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">광택</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.polishType}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">규격</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{data.pdlv}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">베이스</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.PAINTBASE}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">색차이(△E)</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.DF_DELTA_E}}</span>
                                      </li>
                                      <li>
                                        <span class="info-label">조색제 가격</span>
                                        <span class="info-colon">:</span>
                                        <span class="info-value"> {{item.DF_PRICE}}원 / {{data.pdlv}} </span>
                                      </li>
                                    <li class="color-vertical">
                                      <span class="info-label">조색제</span>
                                      <span class="info-colon">:</span>
                                      <span class="info-value">
                                        <span class="color-items">
                                            <span class="color-item" v-if="item.C01 > 0">IOR(W) {{item.C01}}</span>
                                            <span class="color-item" v-if="item.C02 > 0">Green(W) {{item.C02}}</span>
                                            <span class="color-item" v-if="item.C03 > 0">Blue(W) {{item.C03}}</span>
                                            <span class="color-item" v-if="item.C04 > 0">Violet(W) {{item.C04}}</span>
                                            <span class="color-item" v-if="item.C05 > 0">Black(W) {{item.C05}}</span>
                                            <span class="color-item" v-if="item.C06 > 0">White(W) {{item.C06}}</span>
                                            <span class="color-item" v-if="item.C07 > 0">YIO(W) {{item.C07}}</span>
                                            <span class="color-item" v-if="item.C09 > 0">SPRED(W) {{item.C09}}</span>
                                            <span class="color-item" v-if="item.C10 > 0">Yel2GxD(W) {{item.C10}}</span>
                                            <span class="color-item" v-if="item.C11 > 0">MAGENTA(W) {{item.C11}}</span>
                                            <span class="color-item" v-if="item.C12 > 0">Yel.HRD(W) {{item.C12}}</span>
                                            <span class="color-item" v-if="item.C13 > 0">Lem.Yel(W) {{item.C13}}</span>
                                            <span class="color-item" v-if="item.C14 > 0">Br.Org(W) {{item.C14}}</span>
                                            <span class="color-item" v-if="item.C15 > 0">Rbn.Red(W) {{item.C15}}</span>
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                                  </div>
                                  <button type="button" class="c-util-button type-primary btn-print">
                                    <span>배합인쇄</span>
                                  </button>
                                </div>
                              </div>                              
                            </div>
                          </div>

                          <div class="result-card" v-if="data.c18IsVisible">
                            <h4 class="result-card-title">일반조색제 배합</h4>
                            <div class="result-card-content result-card-content-warning">
                              <div class="color-warning">
                                <span class="color-warning-text">일반조색제 사용시 색차이가 크게 발생됩니다.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                </div>
              </div>

            </div>
    <!-- tab content: tab2 - 조색배합문의 -->
    <div
      class="tab-panel"
      role="tabpanel"
      aria-labelledby="tab1-2"
      hidden></div>
    <!-- tab content: tab3 - 업데이트 -->
    <div
      class="tab-panel"
      role="tabpanel"
      aria-labelledby="tab2-3"
      hidden></div>
    <!-- tab content: tab4 - 색상찾기 -->
    <div
      class="tab-panel"
      role="tabpanel"
      aria-labelledby="tab1-4"
      hidden></div>
  </div>
</template>


<script setup name="aiColorMatching">

import {
  onMounted,
  reactive,
  inject,
  ref,
  computed,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import { popoverTrigger } from "@/js/_ui";
import { useRoute } from "vue-router";
import { api } from "@/plugins/api";
import { throttle } from "lodash";


import * as cmUtil from "@/utils/cmUtil.js";


const { isMobile } = cmUtil.useDeviceType();
const url = inject("url_prefix");
const route = useRoute();
const paginationEl = ref(null);
const myInput = ref(null);





/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    deviceType: isMobile.value ? "M" : "P",
  },
  c15IsVisible : false,
  c18IsVisible : false,
  aiToken : "",
  colorCombin15 : [],
  colorCombin18 : [],
  hisApiSn : "",
  paintType : "",
  product : "",
  productNm : "",
  polishType : "",
  pdlv : "",
  cnid : "",
  cbid : "",
  ctype : "",
  searchIndex :"",
  searchHis : "",
  colornameRgbList : [],
  colornameRgbListSearch : [],
  recipeHistList : [],
  recipe15List : [],
  recipe18List : [],
  // 제품명(수성, 유성) selectBox Lsit
  selectBox: {
    list: [],
    paintType: [],
    prodList: [],
    polishTypeList: [],
    pdlvList : [],
  },
  // 컬러북 회사 selectBox Lsit
  selectColorbookBox1: {
    list: [],
  },
  // 전체문의,MY배합 탭
  tabType: true,
  //문의리스트
  colorCombin: {
    flag: false,
    expendIndex: -1, //아코디언 index
    list: [],
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    pageReloadFlag: 0,
    loading: false,
    //조회조건
    search: {
      tabType: null,
      pntSeCd: null, //수성,유성
      prdctSeCd: null, //제품구분(일반,팬톤)
      startRegDt: "",
      endRegDt: "",
      chcPrdctSn: null,
      searchKeyword: null,
      prdctNm : "",       //제품명
      shineTypeNm : "",   //광택
      colorBookNm : "",   //컬러북
      colorNm : "",       //컬러명
      cybSeqNo : "",      //글번호
      rgtr  : ""          //작성자
    },
    init_search: {
      pntSeCd: "", //수성,유성
      prdctSeCd: "", //제품구분(일반,팬톤)
      chcPrdctSn: null,
      searchKeyword: null,
    },
    chkPrdct: {}, //선택한 제품
    chkDate: "",
    chkSpcfct: [], // 색상배합
    combnVolList: [], // 답변완료 > 색상배합 리스트
    SpcfctList: [], // 답변완료 > 규격
    popover: false,
    allStartDate: null,
  },
  route: {
    combnCrcolnQstnSn: 0,
  },
});
  




/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  searchCmd("radio01Chk");
  //await dateCalculation("ALL");

  await getLogin();
  await getPaintTypeList();
  await getAirecipeHist();

  // 스크롤 이벤트 등록
  if (data.page.deviceType == "M") {
    document.addEventListener("scroll", handleScroll);
  }

}



/**********************
 * 마운트
 *********************/
onMounted(async () => {
  pageInit(); // 초기셋팅
  popoverTrigger(); // 팝오버

  if (route.params.id) {
    data.route.combnCrcolnQstnSn = route.params.id;
    data.colorCombin.limit = 100;
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    await searchCmd("search");
    data.colorCombin.pageReloadFlag++;
    goToSelectedPost();
    await loadReplData(route.params.id);
  } else {
    searchCmd("search");
  }
});

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  //data.colorCombin.loading = true;

  // 일반/팬톤 radio 선택 시
  if (cmd === "radio01Chk") {
    data.colorCombin.search.chcPrdctSn = null;
    const res = await api.post(`${url}/colorCombin/selectBox01`, {
      pntSeCd: data.colorCombin.search.pntSeCd,
      prdctSeCd: params.type,
    });

    data.selectBox.list = res.data;
  }
  // 제품명(수성/유성) radio 선택 시
  else if (cmd === "radio02Chk") {
    data.colorCombin.search.chcPrdctSn = null;
    const res = await api.post(`${url}/colorCombin/selectBox01`, {
      pntSeCd: params.type,
      prdctSeCd: data.colorCombin.search.prdctSeCd,
    });

    data.selectBox.list = res.data;
  }
  // 제품유형(수성/유성) select 선택 시
  else if (cmd === "sel01Chk") {
      const aiToken =  data.aiToken ;
      if(aiToken == null || aiToken == ''){
          getLogin();
      }
    const res = await api.post(`${url}/colorCombin/selectGetProductList`, {
      pntSeCd: params.type,
      aiToken: aiToken,
    });

    data.selectBox.prodList = res.data;
  }
  //조회
  else if (cmd === "search") {
    const res = await api.post(`${url}/colorCombin/selectColor01`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });
    if (params["page"] == null || params["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    if(res.data.totalCount > 0){
      if(res.data.list[0].cybYn=="Y"){
        data.colorCombin.flag = true;
      }else{
        data.colorCombin.flag = false;
      }
    }

    data.colorCombin.list = res.data.list;
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
    if (data.route.combnCrcolnQstnSn > 0) {
      for (let i in res.data.list) {
        if (
          res.data.list[i].combnCrcolnQstnSn == data.route.combnCrcolnQstnSn
        ) {
          data.colorCombin.expendIndex = Number(i);
          break;
        }
      }
    }
  }
  // 모바일 조회
  else if (cmd === "scrollSearch") {
    const res = await api.post(`${url}/colorCombin/selectColor01`, {
      ...data.colorCombin.search,
      page: params["page"] || 1,
      limit: params["limit"] || data.colorCombin.limit,
    });

    data.colorCombin.list.push(...res.data.list);
    data.colorCombin.page = params["page"] || 1;
    data.colorCombin.totalCount = res.data.totalCount;
    data.colorCombin.totalPage = data.colorCombin.totalCount
      ? Math.ceil(data.colorCombin.totalCount / data.colorCombin.limit)
      : 0;

    data.colorCombin.expendIndex = -1;
  }

  //await btnCmd("expendClick", { index: -1, clickType: "search" });
  // data.colorCombin.loading = false;
}


const datePair = computed(() => [
  data.colorCombin.search.startRegDt,
  data.colorCombin.search.endRegDt,
]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.colorCombin.search.startRegDt = oldStartDate;
      data.colorCombin.search.endRegDt = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.</br> 다시 확인해주세요."
      );
    }
  }
);

watch(
  () => route.params.id,
  async (newValue) => {
    data.colorCombin.expendIndex = -1;
    data.route.combnCrcolnQstnSn = newValue;
    data.tabType = false;
    data.colorCombin.search.tabType = "my";
    data.colorCombin.limit = 100;
    await searchCmd("search");
    goToSelectedPost();
    await loadReplData(route.params.id);
    data.colorCombin.pageReloadFlag++;
  }
);

// 아코디언 열린 위치로 스크롤 이동
const goToSelectedPost = () => {
  nextTick(() => {
    const id = route.params.id || "";
    if (id) {
      const idEl = document.getElementById(`ID${id}`);
      let positionTop = idEl?.getBoundingClientRect().top || 0;
      if (positionTop > 100) {
        positionTop -= 95;
      }
      window.scroll({ top: positionTop });
    }
  });
};

/**********************
 * 모바일 scroll 조회
 *********************/
const handleScroll = throttle(() => {
  if (
    data.page.deviceType != "M" ||
    data.colorCombin.loading ||
    data.colorCombin.list.length === 0
  ) {
    return;
  }
  data.colorCombin.loading = true;

  const scrollPosition = window.innerHeight + window.scrollY;
  const bottom = document.documentElement.scrollHeight;

  if (scrollPosition >= bottom - 350) {
    searchCmd("scrollSearch", { page: data.colorCombin.page + 1 });
  }
  data.colorCombin.loading = false;
}, 300);

onBeforeUnmount(() => {
  document.removeEventListener("scroll", handleScroll);
});

// 답변 상세데이타 조회
const loadReplData = async (_id = 0) => {
  let idx = -1;
  let params = {};
  for (let i = 0; i < data.colorCombin.list.length; i++) {
    let item = data.colorCombin.list[i];
    if (_id == item.combnCrcolnQstnSn) {
      idx = i;
      params = {
        index: i,
        baseCd: item.baseCd,
        combnCrtrVol: item.combnCrtrVol,
        pntSn: item.pntSn,
        spcfctCd: item.spcfctCd,
        combnCrcolnQstnSn: item.combnCrcolnQstnSn,
        ansRemarkCn: item.ansRemarkCn,
        clickType: "list",
      };

      break;
    }
  }
  if (idx > -1) {
    const resSpcfct = await api.post(`${url}/colorCombin/selectBox03`, {
      pntSn: params.pntSn,
    });
    data.colorCombin.SpcfctList[idx] = resSpcfct.data;

    const res = await api.post(`${url}/colorCombin/selectCombnVolList`, params);
    data.colorCombin.combnVolList[idx] = res.data.filter(
      (item) => item.inputCombnVol != 0
    );
  }
};


// function clickType(param){

//   switch (param) {
//     case 'paintType':
//       getProductList();
//       break;  
//     case 'polishType':
//       getPolishType();
//       break;  
//     case 'pdlv':
//       getPdlv();
//       break;  
//     case 'colorId':
//       getColormameRgb();
//       break;  
//     case 'recipe':
//       getRecipeByCb();
//       break;  
//     default:
//       break;
//   }

// }

//로그인
async function getLogin(){
  const res = await api.post(`${url}/colorCombin/selectGetAiLogin`, {});
  data.aiToken = res.data.aiToken;
  data.hisApiSn = res.data.hisApiSn;
}

// async function getHistory(){
//   const aiToken =  data.aiToken ;
//   if(aiToken == null || aiToken == ''){
//       getLogin();
//   }
//   const res = await api.post(`${url}/colorCombin/selectColorbookCompany`, {});
//   data.selectBox.code06 = res.data;
// }
  

//페인트유형 조회
async function getPaintTypeList(){

getSearchReset();
data.paintType = "";  
data.pdlv = "";  
data.product = "";
data.productNm = "";
data.polishType = "";
data.pdlv = "";
data.cnid = "";
data.cbid  = "";
data.ctype = "";
data.colornameRgbListSearch = [];
data.colornameRgbList = [];
data.selectBox.list = [];
data.selectBox.polishTypeList = [];
data.selectBox.pdlvList = [];
data.selectBox.prodList = [];
data.colornameRgbList = [];
data.recipe15List = [];
data.recipe18List = [];

  const aiToken =  data.aiToken ;
  const hisApiSn = data.hisApiSn;
  const res = await api.post(`${url}/colorCombin/selectGetPaintType`,  {
      aiToken : aiToken,
      hisApiSn : hisApiSn
    });
  data.selectBox.paintType = res.data;
}

//제품명 조회
async function getProductList(){
  
const paintType = data.paintType;

const selectElement = document.querySelector('select[name="productType"]');

// 선택된 값 가져오기
const selectedValue = selectElement.value;
data.productNm = selectedValue;

  
data.pdlv = "";  
data.product = "";
data.productNm = "";
data.polishType = "";
data.pdlv = "";
data.cnid = "";
data.cbid  = "";
data.ctype = "";
data.colornameRgbListSearch = [];
data.colornameRgbList = [];
data.selectBox.list = [];
data.selectBox.polishTypeList = [];
data.selectBox.pdlvList = [];
data.selectBox.prodList = [];
data.colornameRgbList = [];
data.recipe15List = [];
data.recipe18List = [];
  
  const aiToken =  data.aiToken ;
  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  const res = await api.post(`${url}/colorCombin/selectGetProductList`, {
    aiToken : aiToken,
    pType : paintType,
    hisApiSn : data.hisApiSn
  });

  data.selectBox.prodList = res.data;
}

async function getAirecipeHist(){
  const res = await api.post(`${url}/colorCombin/selectGetAiRecipeByCbHist`, {});
  data.recipeHistList = res.data;
}

//광택유형 조회
async function getPolishType(){
  const product = data.product;
  const aiToken =  data.aiToken ;
  
  
  data.pdlv = "";  
  data.polishType = "";
  data.pdlv = "";
  data.cnid = "";
  data.cbid  = "";
  data.ctype = "";
  data.colornameRgbListSearch = [];
  data.colornameRgbList = [];
  data.selectBox.list = [];
  data.selectBox.polishTypeList = [];
  data.selectBox.pdlvList = [];
  data.colornameRgbList = [];
  data.recipe15List = [];
  data.recipe18List = [];

  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  
  const key = String(data.product);
  const found = data.selectBox.prodList.filter(item => key.includes(item.PDGPID))[0];
  const name = found?.PDIDNAME ?? '';
  data.productNm = name;


   const res = await api.post(`${url}/colorCombin/selectGetPolishType`, {
     aiToken : aiToken,
     pdgid : product,
     pdgname : data.productNm,
     hisApiSn : data.hisApiSn,
   });

  data.selectBox.polishTypeList = res.data;
}

// //규격유형 조회
async function getPdlv(){
  
 
  data.colornameRgbListSearch = [];
  data.colornameRgbList = [];
  data.selectBox.pdlvList = [];
  data.recipe15List = [];
  data.recipe18List = [];

    const aiToken =  data.aiToken ;
  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  const res = await api.post(`${url}/colorCombin/selectGetPdlv`, {
    aiToken : aiToken,
    pdgid : data.product,
    pdgname : data.productNm,
    polishType : data.polishType,
    hisApiSn : data.hisApiSn,
  });
  data.selectBox.pdlvList = res.data;
}

// //색상 아이디 조회
async function getColormameRgb(){
  const product = data.colorCombin.search.searchKeyword;
  const aiToken =  data.aiToken ;
  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  if(product.length < 3){
    await cmUtil.alert(            
          "검색어는 3글자 이상을 입력하세요."
      );
    return;
  }


  
  if(data.paintType == null || data.paintType == ''){
    await cmUtil.alert(            
          "제품 유형을 선택해주세요."
      );
    return;
  }
  
  if( data.product == null ||  data.product == ''){
    await cmUtil.alert(            
          "제품명을 선택해주세요."
      );
    return;
  }
  
  if( data.polishType == null ||  data.polishType == ''){
    await cmUtil.alert(            
          "광택을 선택해주세요."
      );
    return;
  }
  
  if( data.pdlv == null ||  data.pdlv == ''){
    await cmUtil.alert(            
          "규격을 선택해주세요."
      );
    return;
  }

  const res = await api.post(`${url}/colorCombin/selectGetColormaneRgb`, {
    aiToken : aiToken,
    pdgname : data.productNm,
    hisApiSn : data.hisApiSn,
    pdgid : product,
  });
  
  if( res.data.length < 1){
    await cmUtil.alert(            
          "조회된 색상이 없습니다."
      );
  }
  data.colornameRgbListSearch = res.data;
  data.colornameRgbList = res.data;
}

async function setRecipeIndex(index){
  const itemsTm = document.querySelectorAll('.color-list .color-item');
  itemsTm.forEach(el => el.classList.remove('is-active'));
  data.searchIndex = index;
  
  // 모든 .item 요소 가져오기
  const items = document.querySelectorAll('.color-list .color-item');
  items[index].classList.add('is-active');
  showOnlyAtIndex(index);

}



async function showOnlyAtIndex(keepIndex) {
  const elements = document.querySelectorAll('.color-list .color-item');
  elements.forEach((el, idx) => {
    el.hidden = idx !== keepIndex; // keepIndex만 보이고 나머진 숨김
  });
}


// 특정 클래스 가진 모든 요소 표시
async function showAllByClass() {
  const elements = document.querySelectorAll('.color-list .color-item');
  elements.forEach(el => {
    el.hidden = false;           // hidden 속성 제거
       el.style.display = "";       // display 초기화 (원래 값 복원)
  });
}



//AI 조색배합 컬러북을 이용한 배합 검색
async function getRecipeByCb15(){
  const index = data.searchIndex;
  const aiToken =  data.aiToken ;
  const dataInfo = data.colornameRgbList[index];

  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  
  
  if(data.paintType == null || data.paintType == ''){
    await cmUtil.alert(            
          "제품 유형을 선택해주세요."
      );
    return;
  }
  
  if( data.product == null ||  data.product == ''){
    await cmUtil.alert(            
          "제품명을 선택해주세요."
      );
    return;
  }
  
  if( data.polishType == null ||  data.polishType == ''){
    await cmUtil.alert(            
          "광택을 선택해주세요."
      );
    return;
  }
  
  if( data.pdlv == null ||  data.pdlv == ''){
    await cmUtil.alert(            
          "규격을 선택해주세요."
      );
    return;
  }
  
  if(data.product == null || data.product == ''){
    await cmUtil.alert(            
          "색상을 조회해주세요."
      );
    return;
  }

  const res = await api.post(`${url}/colorCombin/selectGetAiRecipeByCb`, {
    aiToken : aiToken,
    pdgid : data.product,
    pdgname : data.productNm,
    polishType : data.polishType,
    cbid : dataInfo.CBID,
    cnid : dataInfo.CNID,
    recipeType : 'C15',
    pdlv : data.pdlv,
  });



  data.recipe15List = res.data;

  

  if(res.data.length < 1){
    data.c15IsVisible = true;
    data.c18IsVisible = true;
  }  

  data.cnid = dataInfo.CNID;
  data.cbid = dataInfo.CBID;
  getRecipeByCb18(dataInfo);
}


//AI 조색배합 컬러북을 이용한 배합 검색
async function getRecipeByCb18(dataInfo){
  const aiToken =  data.aiToken ;
  const product = data.product;
  if(aiToken == null || aiToken == ''){
      getLogin();
  }
  const res = await api.post(`${url}/colorCombin/selectGetAiRecipeByCb`, {
    aiToken : aiToken,
    pdgid : product,
    pdgname : data.productNm,

    polishType : data.polishType,
    cbid : dataInfo.CBID,
    cnid : dataInfo.CNID,
    recipeType : 'C12',
    pdlv : data.pdlv,
  });

  

  if(res.data.length < 1){
    data.c18IsVisible = true;
  }  


  if(data.recipe15List.length < 1 && res.data.length < 1){
    await cmUtil.alert(            
          "페인트 프로의 조색배합문의로 요청 등록 바랍니다."
      );
    return;
  }

  

  data.recipe18List = res.data;
  await getAirecipeHist();
}

// async function getSearchRecipe(){
//   const data2 = data.colornameRgbList;
//   const inputElement = data.colorCombin.search.searchKeyword;

//   const filterdData = data2.filter(item => (item.CNID ?? "").toLowerCase().includes(inputElement.toLowerCase()));
//   data.colornameRgbListSearch = filterdData;
// }

async function getSearchReset(){
  data.c18IsVisible = false;
  data.colorCombin.search.searchKeyword = "";
  showAllByClass();
}

async function getProdList(){
  data.colornameRgbListSearch = data.colornameRgbList;
}


// //색상 아이디 조회
async function getColorHis(){
  const res = await api.post(`${url}/colorCombin/selectGetAiRecipeByCbHistInfo`, {
    hisApiSn : data.searchHis,
  });
  data.colorCombin15 = res.data.data.C15;
  data.colorCombin18 = res.data.data.C18;
}

async function getHisSearchReset() {
  data.c18IsVisible = false;
  data.searchHis = "";
  data.colorCombin15 = [];
  data.colorCombin18 = [];
}

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};


</script>